export default __webpack_public_path__ + "static/media/chat-icon.064a71fd.svg";